class LineHeightUtils {
  /**
   * Parses the Editor v1 line height style to get the multiplier value and from that
   * derive the expected lineHeight mark value for block elements.
   */
  static lineHeightDataFromHtmlElement(el: HTMLElement) {
    if (el.style.lineHeight) {
      const lineHeightRegex =
        /calc\(var\(--aha-editor--user-line-height\)((\s*\*\s*)(?<multiplier>\d+(\.\d+)?))?\)/;
      const match = el.style.lineHeight.match(lineHeightRegex);

      if (match?.groups) {
        const lineHeightValue =
          match.groups.multiplier === '1.35' ? '1.3' : match.groups.multiplier;
        return lineHeightValue;
      }
    }

    return null;
  }
}

export default LineHeightUtils;
